import React from 'react'
import { Box, Button, Text } from 'grommet'
import styled from 'styled-components'
import { useHideInput } from '../../contextHook/hideInput'
import ShareModeButton from '../Button/ShareModeButton'

const AbsoluteBox = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
`

const InputShield = ({ page }) => {
  const { setHiding, shareModeActive } = useHideInput()
  return (
    <AbsoluteBox
      width="100%"
      height="100%"
      background="primaryBg"
      align="center"
      pad="2rem"
      round="2rem"
      gap="0.5rem"
    >
      <Text weight={700} color="blackText">
        INPUTS SECTION
      </Text>
      <Text
        size="1.4rem"
        weight={500}
        color="blackText"
        style={{ textDecoration: 'underline' }}
      >
        Hidden - Can't Edit
      </Text>
      {!shareModeActive ? (
        <Button
          onClick={() => {
            setHiding(false)
          }}
          label="CLICK TO EDIT INPUTS"
          primary
          color="iconDark"
          margin="auto 0 auto 0"
          style={{ color: 'var(--whiteText)' }}
          size="small"
        />
      ) : (
        <ShareModeButton atCorner={false} margin="auto 0 auto 0" page={page} />
      )}
    </AbsoluteBox>
  )
}

export default InputShield
